let VUE_APP_IMG_URL = process.env.VUE_APP_IMG_URL
let productList = [
	
	{
	   product_id: 1,
	   prize:'奖励1',
	   product_name:'Folding Bracket',
		product_type:'手机 / 平板通用折叠支架',
		product_src: VUE_APP_IMG_URL + 'sunbathing/gift_mobilePhoneHolder.jpg',
	},
	// {
	//    product_id: 1,
	//    prize:'奖励1',
	//    product_name:'TOZO C1',
	// 	product_type:'充电头',
	// 	product_src: VUE_APP_IMG_URL + 'sunbathing/gift_c1.png',
	// },
	// {
	//    product_id: 2,
	//    prize:'奖励2',
	//    product_name:'TOZO W1',
	// 	product_type:'无线充',
	// 	product_src: VUE_APP_IMG_URL + 'sunbathing/gift_w1.png',
	// }
]

export { productList }